export default __webpack_public_path__ + "static/media/checkmark_filled.ea3c045f.svg";